import React, { useMemo, useState } from 'react';

import { Control, UseFormHandleSubmit, UseFormRegister } from 'react-hook-form';
import { FieldErrors } from 'react-hook-form/dist/types/errors';

import { ILoginForm } from 'components/App/AuthPublicPages/Login/login';
import classes from 'components/App/AuthPublicPages/Login/login.module.scss';
import ActiveDirectory from 'components/App/AuthPublicPages/_common/LoginComponent/ActiveDirectory/activeDirectory';
import { CredentialsForm } from 'components/App/AuthPublicPages/_common/LoginComponent/CredentialsForm/credentialsForm';
import Layout from 'components/App/AuthPublicPages/_common/publicLayout/layout';
import { TabItem, Tabs } from 'components/DesignSystem/Tabs';

interface Props {
    title: string;
    handleSubmit: UseFormHandleSubmit<ILoginForm>;
    login: (data: ILoginForm) => void;
    errors: FieldErrors<ILoginForm>;
    register: UseFormRegister<ILoginForm>;
    control: Control<ILoginForm>;
    error?: string;
    isLoading: boolean;
    enableSSO: boolean;
}
type LoginActiveTab = 'foresightCredentials' | 'organisationalActiveDirectory';

export const LoginComponent = ({
    title,
    handleSubmit,
    login,
    errors,
    register,
    control,
    error,
    isLoading,
    enableSSO,
}: Props) => {
    const [activeTab, setActiveTab] = useState<LoginActiveTab>('organisationalActiveDirectory');
    const viewMode = useMemo(() => (enableSSO ? 'TABS_VIEW' : 'REGULAR_VIEW'), [enableSSO]);

    const tabs: TabItem[] = [
        {
            value: 'organisationalActiveDirectory',
            label: 'Organisational Active Directory',
        },
        {
            value: 'foresightCredentials',
            label: 'Foresight Credentials',
        },
    ];

    return (
        <Layout>
            <div className={`${classes.loginFormWrapper} ${viewMode === 'TABS_VIEW' ? classes.tabsView : ''}`}>
                <div className={classes.loginFormTitleWrapper}>{title}</div>
                {viewMode === 'TABS_VIEW' ? (
                    <>
                        <Tabs
                            tabs={tabs}
                            value={activeTab}
                            onChange={(value) => setActiveTab(value as LoginActiveTab)}
                        />
                        {activeTab === 'foresightCredentials' ? (
                            <CredentialsForm
                                title={title}
                                handleSubmit={handleSubmit}
                                login={login}
                                errors={errors}
                                register={register}
                                control={control}
                                error={error}
                                isLoading={isLoading}
                            />
                        ) : (
                            <>
                                <ActiveDirectory />
                            </>
                        )}
                    </>
                ) : (
                    <CredentialsForm
                        title={title}
                        handleSubmit={handleSubmit}
                        login={login}
                        errors={errors}
                        register={register}
                        control={control}
                        error={error}
                        isLoading={isLoading}
                    />
                )}
            </div>
        </Layout>
    );
};
